var _defs, _rect, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductCharger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 400,
    viewBox: "0 0 640 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c3aed",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ea5e9",
    stopOpacity: 0.18
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 400,
    rx: 26,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(210 78)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 220,
    height: 220,
    rx: 26,
    fill: "#0b1220",
    stroke: "rgba(148,163,184,.35)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 54,
    width: 112,
    height: 112,
    rx: 22,
    fill: "rgba(34,197,94,.18)",
    stroke: "rgba(229,231,235,.12)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 78l-22 44h26l-10 44 30-56h-26l12-32z",
    fill: "rgba(229,231,235,.85)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70 222)",
    stroke: "rgba(229,231,235,.45)",
    strokeWidth: 6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 0,
    x2: 80,
    y2: 24
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 64,
    fill: "rgba(229,231,235,.9)",
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto",
    fontWeight: 800,
    fontSize: 26
  }, "VoltDock 65W")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 94,
    fill: "rgba(148,163,184,.95)",
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto",
    fontWeight: 600,
    fontSize: 15
  }, "Fast charger + GaN efficiency")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCharger);
export default __webpack_public_path__ + "static/media/product-charger.25dab10ee1eb3200752c9546084c6064.svg";
export { ForwardRef as ReactComponent };